(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .constant('pagarmeConstants', {
            API_VERSION: {
                V4: 'V4',
                V5: 'V5',
                SHOWKASE_PAY: 'SHOWKASE_PAY',
                SHOWKASE_PAY_V5: 'SHOWKASE_PAY_V5'
            },
            KYC_STATUS: {
                PENDING: 'pending',
                PARTIALLY_DENIED: 'partially_denied',
                APPROVED: 'approved',
                DENIED: 'denied'
            },
            RECIPIENT_STATUS: {
                PROCESSING: 'processing',
                REGISTRATION: 'registration',
                AFFILIATION: 'affiliation',
                ACTIVE: 'active',
                REFUSED: 'refused',
                SUSPENDED: 'suspended',
                BLOCKED: 'blocked',
                INACTIVE: 'inactive',
                NONE: 'none'
            },
            RECIPIENT_TYPE: {
                INDIVIDUAL: 'individual',
                CORPORATION: 'corporation'
            },
            BANK_ACCOUNT_TYPE: {
                COMPANY: 'company',
                INDIVIDUAL: 'individual'
            },
            TRANSFER_INTERVAL_OPTIONS: {
                DAILY: 'daily',
                WEEKLY: 'weekly',
                MONTHLY: 'monthly'
            },
            BANK_ACCOUNT_TYPE_OPTIONS: {
                CONTA_CORRENTE: 'conta_corrente',
                CONTA_POUPANCA: 'conta_poupanca'
            }
        });

})();
